import { render, staticRenderFns } from "./RightShipYearlyChart.vue?vue&type=template&id=01b38bb0&scoped=true&"
import script from "./RightShipYearlyChart.vue?vue&type=script&lang=js&"
export * from "./RightShipYearlyChart.vue?vue&type=script&lang=js&"
import style0 from "./RightShipYearlyChart.vue?vue&type=style&index=0&id=01b38bb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b38bb0",
  null
  
)

export default component.exports